import React from 'react';
import { getTheme, IStyle, ITheme, mergeStyleSets, Text } from '@fluentui/react';
import { Col, BwjGrid, Row } from '../../framework/components/bwj-layout';

const getStyleClasses = (theme: ITheme) => {
  const footer: IStyle = {
    padding: 15,
    backgroundColor: theme.palette.neutralLight,
  };

  const linkList: IStyle = {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'flex-end',
    fontSize: 14,
    '& > li': {
      display: 'block',
    },
  };

  const link: IStyle = {
    textDecoration: 'none',
    color: theme.palette.themePrimary,
    '&:hover': {
      textDecoration: 'underline',
    },
  };

  const linkDivider: IStyle = {
     padding: '0 5px',
  };

  return mergeStyleSets({
    footer,
    linkList,
    link,
    linkDivider,
  });
}

export const AppFooter: React.FunctionComponent = (props) => {

  const theme = getTheme();
  const cs = getStyleClasses(theme);

  return (
    <footer className={cs.footer}>
      <BwjGrid>
        <Row>
          <Col medium={6} small={12}>
            <Text variant="medium">&copy; {(new Date()).getFullYear()} BWJ, LLC.  All rights reserved.</Text>
          </Col>
          <Col medium={6} small={12}>
            <ul className={cs.linkList}>
              <li><a className={cs.link} href="https://bwjstorm.com/contact" rel="noreferrer" target="_blank">Contact</a></li>
              <li className={cs.linkDivider}>|</li>
              <li><a className={cs.link} href="https://bwjstorm.com/terms" rel="noreferrer" target="_blank">Terms of Use</a></li>
              <li className={cs.linkDivider}>|</li>
              <li><a className={cs.link} href="https://bwjstorm.com/privacy" rel="noreferrer" target="_blank">Privacy</a></li>
            </ul>
          </Col>
        </Row>
      </BwjGrid>
    </footer>
  );
};
